export default __webpack_public_path__ + "static/media/naira-banner-bg.b2ee674b.png";